import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white" role="contentinfo">
      {/* Upper Section */}
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-2xl font-black tracking-tight">
                51<span className="text-accent-500">黑料</span>网
              </span>
            </Link>
            <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
              一站式网红吃瓜、明星黑料、热门事件爆料平台。每日大赛内容不间断，吃瓜群众首选入口。
            </p>
            <p className="mt-3 text-xs text-white/30">
              &copy; 2026 51黑料网 版权所有
            </p>
          </div>

          {/* Column 2: Newsletter */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4">
              订阅爆料
            </h4>
            <form
              data-readdy-form="true"
              id="footer-subscribe-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget as HTMLFormElement;
                const formData = new FormData(form);
                const websiteAlt = (formData.get('website_alt') as string || '').trim();
                if (websiteAlt) {
                  const msg = document.getElementById('footer-sub-status');
                  if (msg) { msg.textContent = '订阅成功！感谢关注。'; msg.className = 'text-xs text-accent-400 mt-2'; }
                  form.reset();
                  return;
                }
                try {
                  const res = await fetch('https://form.readdy.ai/submit', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ email: formData.get('email') as string || '' }).toString(),
                  });
                  const text = await res.text();
                  let ok = false;
                  try {
                    const p = JSON.parse(text);
                    ok = res.ok && p?.code === 'OK';
                  } catch { ok = res.ok; }
                  const el = document.getElementById('footer-sub-status');
                  if (el) {
                    el.textContent = ok ? '订阅成功！感谢关注。' : '订阅失败，请稍后再试。';
                    el.className = ok ? 'text-xs text-accent-400 mt-2' : 'text-xs text-red-400 mt-2';
                  }
                  if (ok) form.reset();
                } catch {
                  const el = document.getElementById('footer-sub-status');
                  if (el) { el.textContent = '网络错误，请稍后再试。'; el.className = 'text-xs text-red-400 mt-2'; }
                }
              }}
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱订阅每日爆料"
                  required
                  className="w-full bg-transparent border-0 border-b border-white/20 py-2 pr-10 text-sm text-white placeholder-white/30 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-0 top-1/2 -translate-y-1/2 text-white/50 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap"
                  aria-label="订阅"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              <p className="text-xs text-white/25 mt-2">
                订阅即表示同意我们的{' '}
                <a href="/about" className="underline cursor-pointer hover:text-white/50 transition-colors">隐私政策</a>
              </p>
              <input
                type="text"
                name="website_alt"
                className="field-website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <p id="footer-sub-status" className="text-xs mt-2"></p>
            </form>
          </div>

          {/* Column 3: Quick Links */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap">
                  今日黑料首页
                </Link>
              </li>
              <li>
                <Link to="/category/yiqu" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap">
                  一区 · 明星娱乐
                </Link>
              </li>
              <li>
                <Link to="/category/erqu" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap">
                  二区 · 网红达人
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Social */}
          <div className="lg:col-span-1">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4">
              关注我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap inline-flex items-center gap-2" rel="nofollow">
                  <i className="ri-weibo-line"></i> 微博
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap inline-flex items-center gap-2" rel="nofollow">
                  <i className="ri-wechat-line"></i> 微信公众号
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/60 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap inline-flex items-center gap-2" rel="nofollow">
                  <i className="ri-telegram-line"></i> Telegram频道
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Brand Banner */}
      <div className="w-full bg-primary-950/80 py-10 md:py-14 overflow-hidden">
        <div className="px-6 md:px-10">
          <p className="font-heading text-5xl md:text-8xl lg:text-9xl font-black text-white/8 leading-none tracking-tighter select-none whitespace-nowrap">
            51HEILIAOWANG
          </p>
        </div>
      </div>
    </footer>
  );
}